export default [
  {
    path: '/admin/table-profiles',
    name: 'table-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/booking/table-profile')
  }
]
